import { useEffect } from 'react';

/**
 * Registers a single-key global shortcut (e.g. "/" for search, "?" for
 * help). Ignored while the user is actively typing in a text field — a
 * global "/" hijacking normal typing in a search box or textarea would be
 * broken, not helpful.
 */
export default function useGlobalShortcut(key, handler, { enabled = true } = {}) {
  useEffect(() => {
    if (!enabled) return undefined;

    const onKeyDown = (e) => {
      if (e.key !== key) return;
      const target = e.target;
      const isTyping = target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable);
      if (isTyping) return;
      e.preventDefault();
      handler(e);
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [key, handler, enabled]);
}
